import script from "./ProfileSettingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSettingsPage.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSettingsPage.vue?vue&type=style&index=0&id=19385a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19385a94"]])

export default __exports__